<template>
  <v-card class="elevation-2" style="max-width: 100%;">
    <v-card-title class="pb-2 pt-2">
      <span
        style="font-size: 12px;"
        class="primary--text"
      >Capital and Revenues {{currencyId ? "" : " (using foreign exchange rate)"}}</span>
      <v-tooltip right>
        <v-icon small color="#ccc" slot="activator" class="pl-2">help</v-icon>
        <span>DESCRIPTION</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="previousYear">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ selectedYear }}</div>
      <v-btn small icon flat @click="nextYear">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-0">
      <v-layout row wrap align-center v-if="!loading">
        <v-flex xs12>
          <apexchart type="area" width="100%" height="350px" :options="options" :series="series" />
        </v-flex>
      </v-layout>

      <!-- <v-layout row justify-center align-center v-if="!loading && !series.length" class="pa-4">
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No expenses found
        </span>
      </v-layout>-->

      <div class="pa-4 text-xs-center" v-if="loading">
        <looping-rhombuses-spinner
          style="margin: auto;"
          class="text-xs-center"
          :animation-duration="1000"
          :size="74"
          color="#1976d2"
        />
        <h3 class="title font-weight-light my-2">Loading Chart...</h3>
        <span class="caption grey--text">Please wait</span>
      </div>
    </v-card-text>
    <!-- {{firstDayOfYear(selectedYear)}}
    {{lastDayOfYear(selectedYear)}}-->
    <!-- <json-viewer :value="fetchedData"></json-viewer>
    <json-viewer :value="series"></json-viewer>-->

    <!--  <json-viewer :value="parsedDataByDate"></json-viewer>-->
  </v-card>
</template>

<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import date from "../../../mixins/date";
import INVOICES_BY_YEAR from "../../../graphql/accounting/invoices_by_year.gql";
import JsonViewer from "vue-json-viewer";
import { LoopingRhombusesSpinner } from "epic-spinners";
import currency from "../../../mixins/currency";

export default {
  name: "capitalGraph",

  components: { apexchart, JsonViewer, LoopingRhombusesSpinner },
  mixins: [date, currency],
  props: {
    currencyId: {
      type: String,
      required: true,
    },
    subsidiaryId: {
      type: String,
      required: false,
      default: "",
    },
    exchangeRates: {
      type: Array,
      required: false,
    },
    exchangeRatesBaseCurrencyID: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      loading: true,
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      fetchedData: this.resetFetchedData(),
      options: {
        tooltip: {
          shared: true,
          followCursor: true,
        },
        fill: {
          opacity: [0.3, 0.3, 0.1, 0.1],
          type: ["gradient", "gradient", "gradient", "gradient"],
          gradient: {
            opacityFrom: [0.2, 0.2, 0.4, 0.4],
            opacityTo: [0.9, 0.9, 0, 0],
          },
        },
        // yaxis: {
        //   labels: {
        //     formatter: this.formatterCurrency,
        //   },
        // },

        yaxis: [
          {
            seriesName: "Sales",
            labels: {
              formatter: this.formatterCurrency,
            },
            title: {
              text: "Columns",
            },
          },
          {
            seriesName: "Sales",
            show: false,
            labels: {
              formatter: this.formatterCurrency,
            },
          },
          {
            seriesName: "Sales",
            show: false,
            labels: {
              formatter: this.formatterCurrency,
            },
          },
          {
            seriesName: "Sales",
            show: false,
            labels: {
              formatter: this.formatterCurrency,
            },
          },
          {
            opposite: true,
            seriesName: "ROI",
           labels: {
              formatter: this.percentageFormatter,
            },
            title: {
              text: "Return On Investement (%)",
            },
          },
        ],

        dataLabels: {
          enabled: true,
          enabledOnSeries: [],
        },
        chart: {
          height: 350,
          type: "area",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
        },
        stroke: {
          curve: "smooth",
          width: [0, 0, 2, 2, 4],
          dashArray: [0, 0, 0,0, 5]
        },
        xaxis: {
          type: "datetime",

          // zoom: {
          //   autoScaleXaxis: true
          // }
        },
      },
    };
  },
  computed: {
    // ...mapGetters("commonStore", ["accountTypes"]),
    series() {
      var salesArr = []; //Sales month per month
      var purchasesArr = []; //Purchases month per month
      var turnOverArr = []; // turn Over ( acumulated sales)
      var profitArr = []; // profit ( acumulated sales - acumulated purchases)
      var returnOnInvestementArr = []; //

      var total_sales = 0;
      var total_purchases = 0;
      Object.keys(this.fetchedData.bank_invoices).forEach((date) => {
        // console.log("Sales Before Change Rate", this.fetchedData.bank_invoices[date].customer.total_amount)
        // if (!this.currencyId)
        // console.log("NO CURRENCY")
        // console.log("Sales After Change Rate", this.fetchedData.bank_invoices[date].customer.total_amount)
        var customer_total_amount = this.fetchedData.bank_invoices[date]
          .customer.total_amount;
        var supplier_total_amount = this.fetchedData.bank_invoices[date]
          .supplier.total_amount;

        salesArr.push({
          x: date,
          y: customer_total_amount,
        });
        purchasesArr.push({
          x: date,
          y: supplier_total_amount,
        });

        total_sales += customer_total_amount;
        total_purchases += supplier_total_amount;

        turnOverArr.push({ x: date, y: total_sales });
        profitArr.push({ x: date, y: total_sales + total_purchases });
        returnOnInvestementArr.push({
          x: date,
          y: total_sales == 0 ? 0 : ((total_sales + total_purchases) / total_sales) * 100,
         
        });
       // console.log(((total_sales + total_purchases) / total_sales) * 100)
      });

      var retArr = [
        {
          name: "Sales",
          data: salesArr,
          color: "#00e395",
          type: "area",
        },
        {
          name: "Purchases",
          data: purchasesArr,
          color: "#e30033",
          type: "area",
        },
        {
          name: "Turnover",
          data: turnOverArr,
          color: "#ffa000",
          type: "area",
        },
        {
          name: "Profit",
          data: profitArr,
          color: "#008ffb",
          type: "area",
        },
        {
          name: "ROI (Return On Investement)",
          data: returnOnInvestementArr,
          color: "#008ffb",
          type: "line",
        },
      ];

     // console.log("sales", retArr[0].data.length);
      //console.log("purchases", retArr[1].data.length);
      return retArr;
    },
  },
  methods: {
    exchangeRateConverter(amount, currency_id) {
      var retValue = amount;
      if (!this.currencyId && this.exchangeRates.length) {
        var exr = this.exchangeRates.find((exr) => exr.id == currency_id);
        if (exr) {
          retValue *= 1 / exr.exchange_rate;
        }
      }

      return retValue;
    },
    formatterCurrency(val) {
      if (!this.currencyId && this.exchangeRatesBaseCurrencyID)
        return this.inCurrencyFromId(this.exchangeRatesBaseCurrencyID, val);
      else return this.inCurrencyFromId(this.currencyId, val);
    },
    percentageFormatter(val) {
       
        return  val.toFixed(2)+"%";
    },
    resetFetchedData() {
      return {
        bank_invoices: {},
      };
    },
    buildDataset(data) {
      this.fetchedData = this.resetFetchedData();

      //Retrieve all dates and  Make them unique
      var tempDateArr = [
        ...new Set(data.bank_invoices.map((inv) => inv.invoice_date).sort()),
      ];

      //Init objets and default values
      tempDateArr.forEach((td) => {
        this.fetchedData.bank_invoices[td] = {
          customer: {
            total_amount: 0,
            references: [],
          },
          supplier: {
            total_amount: 0,
            references: [],
          },
        };
      });

      data.bank_invoices.forEach((inv) => {
        if (inv.company.customer) {
          var tempAmount = this.exchangeRateConverter(
            inv.amount,
            inv.currency_id
          );

          this.fetchedData.bank_invoices[
            inv.invoice_date
          ].customer.total_amount +=
            inv.operation_type == "credit" ? tempAmount : -tempAmount;
          this.fetchedData.bank_invoices[
            inv.invoice_date
          ].customer.references.push(inv.designation);
        } else if (inv.company.supplier) {
          var tempAmount = this.exchangeRateConverter(
            inv.amount,
            inv.currency_id
          );

          this.fetchedData.bank_invoices[
            inv.invoice_date
          ].supplier.total_amount +=
            inv.operation_type == "credit" ? tempAmount : -tempAmount;
          this.fetchedData.bank_invoices[
            inv.invoice_date
          ].supplier.references.push(inv.designation);
        }
      });

      // this.fetchedData.bank_invoices.allDates.forEach(d => {
      //   this.fetchedData.bank_invoices.
      // });

      // data.bank_invoices.forEach(inv => {
      //   if (inv.company.customer) {
      //     if (!(inv.invoice_date in ))
      //     this.fetchedData.customer.data.push
      //   }
      // });
    },
    fetchData() {
      this.loading = true;
      var filter_invoices = "";
      var sY = this.selectedYear;

      //Date
      filter_invoices =
        "invoice_date >= '" +
        sY +
        "-01-01' && invoice_date <= '" +
        sY +
        "-12-31'";
      if (this.currencyId)
        filter_invoices += " && currency_id == '" + this.currencyId + "'";
      if (this.subsidiaryId)
        filter_invoices +=
          " && subsidiary_company_id == '" + this.subsidiaryId + "'";
      this.sendQuery(INVOICES_BY_YEAR, { filter_invoices: filter_invoices })
        .then((data) => {
          this.buildDataset(data);

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    nextYear() {
      this.selectedYear += 1;
      this.fetchData();
    },
    previousYear() {
      this.selectedYear -= 1;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    currencyId() {
      this.fetchData();
    },
    subsidiaryId() {
      this.fetchData();
    },
    exchangeRates: {
      handler: function (val, oldVal) {
        this.fetchData();
      },
      deep: true,
    },
    exchangeRatesBaseCurrencyID() {
      this.fetchData();
    },
  },
};
</script>
